import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section className="w-full py-20 px-6 md:px-8" style={{
    background: 'linear-gradient(to bottom, #FFF8F0, #E8E0F0 20%, #C4B5E0 45%, #6D5E85 70%, #5C4A7A)',
    paddingTop: '80px',
    paddingBottom: '80px'
  }} data-id="element-247">
      <div className="max-w-2xl mx-auto text-center" data-id="element-248">
        {/* HEADLINE */}
        <h2 className="md:text-5xl font-bold text-text mb-5 text-[36px]" data-id="element-249">
          El posparto no espera.
          <br data-id="element-250" />
          Tu guión tampoco debería.
        </h2>

        {/* ANCHOR PHRASE */}

        {/* MAIN COPY */}
        <div className="text-base md:text-lg text-text/80 leading-relaxed mb-12 space-y-3" data-id="element-251">
          <p data-id="element-252">Cada día sin estructura es energía que gastas...</p>
          <p className="font-semibold text-lg md:text-xl text-text" data-id="element-253">
            Necesitas un guión
          </p>
          <p data-id="element-254">
            Algo que te diga qué hacer día por día durante tu primer mes; cuando
            estás cansada, sensible y sin ganas de improvisar.
          </p>
          <p className="font-semibold text-[#3D3250] text-[24px] font-['Tiro_Gurmukhi',_serif]" data-id="element-255">
            No te prometo "un posparto hermoso".
          </p>
          <p className="text-[28px] font-[600] font-['Tiro_Gurmukhi',_serif] text-[#9F8CB8]" data-id="element-256">
            Te prometo algo mejor: Un Plan Para Hoy.
          </p>
        </div>

        {/* DIVIDER */}
        <div className="border-t border-lavender/40 my-10 max-w-xs mx-auto bg-[#9F8CB8E6]" data-id="element-257" />

        {/* TUS 3 MODOS DEL DÍA */}
        <div className="mb-12" data-id="element-258">
          <h3 className="text-xl md:text-2xl font-bold text-text mb-6" data-id="element-259">
            Porque no todos los días puedes igual:
          </h3>

          <div className="space-y-4 text-left max-w-md mx-auto mb-6" data-id="element-260">
            <div className="flex items-start gap-3 bg-white/50 rounded-2xl px-5 py-4 border border-lavender/30" data-id="element-261">
              <span className="text-2xl flex-shrink-0" data-id="element-262">🔴</span>
              <div data-id="element-263">
                <p className="text-text font-bold text-base" data-id="element-264">
                  Modo Supervivencia
                </p>
                <p className="text-text-light text-sm mt-0.5" data-id="element-265">
                  → Lo mínimo. Y es suficiente.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white/50 rounded-2xl px-5 py-4 border border-lavender/30" data-id="element-266">
              <span className="text-2xl flex-shrink-0" data-id="element-267">🟡</span>
              <div data-id="element-268">
                <p className="text-text font-bold text-base" data-id="element-269">Modo Estándar</p>
                <p className="text-text-light text-sm mt-0.5" data-id="element-270">
                  → Lo básico con un poco más.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-white/50 rounded-2xl px-5 py-4 border border-lavender/30" data-id="element-271">
              <span className="text-2xl flex-shrink-0" data-id="element-272">🟢</span>
              <div data-id="element-273">
                <p className="text-text font-bold text-base" data-id="element-274">Modo Buen día</p>
                <p className="text-text-light text-sm mt-0.5" data-id="element-275">
                  → Aprovechas cuando puedes.
                </p>
              </div>
            </div>
          </div>

          <p className="italic max-w-md mx-auto text-[18px] pl-[5px] pr-[5px] text-[#3D3250]" data-id="element-276">
            Eso evita el ciclo que conoces: hoy hice mucho → mañana no puedo→ me
            siento culpable → abandono todo. <br data-id="element-277" />
            <strong data-id="element-278">Aquí no abandonas.</strong>
            <br data-id="element-279" />
            <strong data-id="element-280">Solo cambias de modo.</strong>
          </p>
        </div>

        {/* REENCUADRE FINAL */}
        <div className="mb-8" data-id="element-281">
          <div className="border-t border-lavender/40 my-10 max-w-xs mx-auto bg-[#C4B5E0]" data-id="element-282" />
          <p className="italic font-normal text-white mb-3 font-['Tiro_Gurmukhi',_serif] text-[32px]" data-id="element-283">
            El plan que te sostiene cuando nadie más puede.
          </p>
          <p className="md:text-xl text-white font-[400] text-[18px]" data-id="element-284">
            Hoy, lo tienes en solo 2 minutos...
          </p>
        </div>

        {/* COMMITMENT BOX */}
        <div className="rounded-2xl px-8 py-8 max-w-md mx-auto mb-10 shadow-sm bg-[#E8E0F0E4] pt-[5px] pb-[5px] pl-[30px] pr-[30px] ml-[60px] mr-[60px]" data-id="element-285">
          <p className="text-[#3D3250] md:text-2xl font-semibold text-center text-[18px]" data-id="element-286">
            Lo abro ahora.
            <br data-id="element-287" />
            Hago el Día 1.
            <br data-id="element-288" />
            Respiro.
          </p>
        </div>

        {/* DATOS RÁPIDOS */}
        <p className="text-sm text-white/70 mb-8" data-id="element-289">
          📄 Ebook de acción inmediata · 7 minutos al día · 27 páginas · En
          español
        </p>

        {/* CTA BUTTON */}
        <a href="https://shop.magneticademente.com/cart/52272543695127:1" onClick={trackAddToCart} className="inline-flex gap-2 text-[#5C4A7A] hover:bg-white/90 px-10 py-5 rounded-full text-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 mb-4 pl-[10px] pr-[10px] items-center justify-center bg-[#FFF8F0]" data-id="element-290">
          ¡Descargar mi guión ya! → $6.36
        </a>

        {/* SUBTEXT BELOW BUTTON */}
        <p className="text-sm text-white/70 mb-10" data-id="element-291">
          📥 Acceso digital inmediato · Compatible con celular/iPad
        </p>

        {/* GUARANTEE BOX */}
        <div className="bg-white/10 border border-white/20 rounded-2xl px-6 py-6 max-w-md mx-auto" data-id="element-292">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-293">
            <ShieldCheck className="w-6 h-6 text-green-300" data-id="element-294" />
            <span className="text-white font-bold text-base" data-id="element-295">
              Garantía de 7 días sin preguntas.
            </span>
          </div>
          <p className="text-white/80 text-sm leading-relaxed" data-id="element-296">
            Si no te ayuda a sentirte más sostenida en 7 días, te devuelvo el
            dinero.
            <br data-id="element-297" />
            <strong data-id="element-298">Porque a $6.36, el riesgo es cero.</strong>
            <br data-id="element-299" />
            El costo de seguir sin un plan, no.
          </p>
        </div>
      </div>
    </section>;
}